"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _ExtrasOrderItem = _interopRequireDefault(require("./ExtrasOrderItem"));
var _newComponents = require("../new-components");
var _pricing = require("../helpers/pricing");
var _ExtrasOrdersRow = _interopRequireDefault(require("./ExtrasOrdersRow"));
var ExtrasOrders = function ExtrasOrders(_ref) {
  var orders = _ref.orders,
    mainOrder = _ref.mainOrder;
  var orderItems = [];
  var hasFeePayment = false;
  var groupedOrderItems = orders.reduce(function (result, order) {
    if (order.status !== _constants.ORDER.PAID_STATUS || order.id === mainOrder.id) {
      return result;
    }
    var profile = order.profile;
    // Check if the profile already exists in the result
    if (!result[profile.id]) {
      // If it doesn't exist, create a new entry with an empty array
      result[profile.id] = [];
    }
    var formattedPayments = (0, _pricing.handleCardFeePayments)(order.payments);
    formattedPayments.forEach(function (payment) {
      if (!!payment.feePayment) {
        hasFeePayment = true;
      }
    });

    // Push the current order into the profile's array
    order.orderItems.forEach(function (item) {
      // add profile on order item
      item.profile = profile;
      item.currency = order.currency;
      item.payments = formattedPayments;
      result[profile.id].push(item);
    });
    return result;
  }, {});
  orders.forEach(function (order) {
    if (order.status !== _constants.ORDER.PAID_STATUS || order.id === mainOrder.id) {
      return;
    }
    order.orderItems.forEach(function (item) {
      return orderItems.push( /*#__PURE__*/_react["default"].createElement(_ExtrasOrderItem["default"], {
        key: item.id,
        order: order,
        item: item
      }));
    });
  });
  if (Object.keys(groupedOrderItems).length < 1) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-lg"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "margin-bottom-md"
  }, "Order history"), /*#__PURE__*/_react["default"].createElement(_newComponents.Table, null, /*#__PURE__*/_react["default"].createElement(_newComponents.TableHead, null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Name"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Item"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Total"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Status"), hasFeePayment && /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Fee"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Paid")), /*#__PURE__*/_react["default"].createElement("tbody", null, Object.keys(groupedOrderItems).map(function (profileId) {
    var orderItems = groupedOrderItems[profileId];
    return orderItems.map(function (item) {
      var payment = item.payments.filter(function (p) {
        return p.ourReference !== _constants.CREDIT_CARD_FEE_REFERENCE;
      })[0];
      if (!payment) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_ExtrasOrdersRow["default"], {
        key: item.id,
        item: item,
        hasFeePayment: hasFeePayment,
        payment: payment
      });
    });
  }))));
};
ExtrasOrders.propTypes = {
  orders: _propTypes["default"].array,
  mainOrder: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ExtrasOrders;